
export const SET_SESSION_ID = 'SET_SESSION_ID'
export const SET_SUBSCRIPTION_ERROR = 'SET_SUBSCRIPTION_ERROR'
export const SET_SUBSCRIPTION_READY = 'SET_SUBSCRIPTION_READY'
export const SET_VIN_IMPORT_EVENT = 'SET_VIN_IMPORT_EVENT'
export const SET_CREATE_FROM_DRAFT_EVENT = 'SET_CREATE_FROM_DRAFT_EVENT'
export const SET_CREATE_FROM_DRAFT_MODAL_OPEN = 'SET_CREATE_FROM_DRAFT_MODAL_OPEN'
